export default "__VITE_ASSET__BfOBWxoX__"